import { useFeatureFlagsStore } from '@/stores/useFeatureFlags';
import { featureFlagSlugs } from '@/constants/featureFlagSlugs';

export const useIsTutorialsEnabled = () => {
  const featureFlagsStore = useFeatureFlagsStore();

  const isTutorialsEnabled = computed(() =>
    featureFlagsStore.getByFlagName(featureFlagSlugs.transportOnboarding),
  );

  return { isTutorialsEnabled };
};
